import React, { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, Route, Routes, useLocation } from "react-router-dom";
import { Tab, Tabs } from "@mui/material";
import Photos from "@components/Home/Photos";
import Faces from "@components/Home/Faces/Faces";
import AlbumRoutes from "@components/Home/AlbumRoutes";
import HomePageTitle from '@components/Home/HomePageTitle/HomePageTitle';
import PageWrapper from "@components/Home/PageWrapper";

enum GalleryTab {
  Photos = "Photos",
  Faces = "Faces",
  Albums = "Albums",
}

const Gallery: FC = () => {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState<GalleryTab>(GalleryTab.Photos);

  const location = useLocation();

  useEffect(() => {
    let tab = GalleryTab.Photos;
    if (location?.pathname?.includes("faces")) {
      tab = GalleryTab.Faces;
    } else if (location?.pathname?.includes("albums")) {
      tab = GalleryTab.Albums;
    }
    setSelectedTab(tab);
  }, [location]);

  return (
    <PageWrapper>
      <HomePageTitle title={t("gallery.title")} />
      <Tabs value={selectedTab} sx={{ marginBottom: "32px" }}>
        <Tab
          label={t("photos.title")}
          value={GalleryTab.Photos}
          component={Link}
          to="photos"
        />
        <Tab
          label={t("faces.title")}
          value={GalleryTab.Faces}
          component={Link}
          to="faces"
        />
        <Tab
          label={t("albums.title")}
          value={GalleryTab.Albums}
          component={Link}
          to="albums"
        />
      </Tabs>

      <Routes>
        <Route path="" element={<Photos />} />
        <Route path="faces" element={<Faces />} />
        <Route path="albums/*" element={<AlbumRoutes />} />
        <Route path="*" element={<Photos />} />
      </Routes>
    </PageWrapper>
  );
};

export default Gallery;
